// libraries
import React from 'react'
import clsx from 'clsx'

// components
import Image from '/react4xp/components/Image'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

export interface ContentBlockHorizontalProps {
    img?: {
        src: string
        alt: string
    }
    title?: string
    text?: string
}

export default function ContentBlockHorizontal({
    img,
    title,
    text
}: ContentBlockHorizontalProps) {
    return (
        <div className='content-block-horizontal'>

            <div className={clsx(
                'content-block-horizontal__image',
                !img?.src && 'content-block-horizontal__image--no-image'
            )}>
                {isNonWhitespaceString(img?.src) && (
                    <Image
                        src={img.src}
                        alt={img.alt}
                        className='cover'
                    />
                )}
            </div>

            <div className='content-block-horizontal__content'>

                {isNonWhitespaceString(title) && (
                    <p className='title text-lg'>
                        {title}
                    </p>
                )}

                {isNonWhitespaceString(text) && (
                    <div
                        className='text'
                        dangerouslySetInnerHTML={{ __html: text }}
                        suppressHydrationWarning
                    />
                )}

            </div>

        </div>
    )
}

